if ($('.in-index').length) {
    $('footer#footer').before($('.categories'));
    $('footer#footer').before($('.mnohoDuvodu'));
    $('footer#footer').before($('.benefits'));
    $('footer#footer').before($('.findUs'));

}